(() => {
  const boot = () => {
    const mobile = matchMedia('(max-width: 749px)');
    const header = document.querySelector('#header-component');
    const section = header?.closest('.header-section');
    const group = document.querySelector('#header-group');
    const vehicle = document.querySelector('.mayhem-setup-bar');
    if (!header || !section) return;
    // One sticky block reserves real document space on collection and product pages.
    const stackPage = !!document.querySelector('collection-component, .product-information');
    const vehicleHome = document.createComment('mayhem-vehicle-toolbar-home');
    if (stackPage && group && vehicle) vehicle.before(vehicleHome);
    const syncStack = () => {
      const enabled = mobile.matches && stackPage && !!group && !!vehicle;
      if (enabled && vehicle.parentElement !== group) group.append(vehicle);
      if (!enabled && vehicleHome.parentNode && vehicle.parentElement === group) vehicleHome.after(vehicle);
      document.body.toggleAttribute('data-mayhem-mobile-stack', enabled);
    };
    let frame = 0;
    const update = () => {
      frame = 0;
      syncStack();
      if (!mobile.matches) {
        document.body.removeAttribute('data-mayhem-near-top');
        document.body.removeAttribute('data-mayhem-mobile-scrolled');
        document.documentElement.style.removeProperty('--mayhem-mobile-clearance');
        document.documentElement.style.removeProperty('--mayhem-mobile-header-height');
        document.documentElement.style.removeProperty('--mayhem-mobile-vehicle-height');
        return;
      }
      document.body.toggleAttribute('data-mayhem-mobile-scrolled', Math.max(0, scrollY) > 24);
      const vehicleHeight = Math.ceil(vehicle?.offsetHeight || 0);
      const stacked = document.body.hasAttribute('data-mayhem-mobile-stack');
      const headerHeight = Math.ceil(stacked
        ? Math.max(header.offsetHeight, group.offsetHeight - vehicleHeight)
        : (group?.offsetHeight || header.offsetHeight));
      const height = headerHeight + vehicleHeight;
      document.documentElement.style.setProperty('--mayhem-mobile-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--mayhem-mobile-vehicle-height', `${vehicleHeight}px`);
      document.body.toggleAttribute('data-mayhem-near-top', Math.max(0, scrollY) <= height + 24);
      document.documentElement.style.setProperty('--mayhem-mobile-clearance', `${height + 16}px`);
      window.dispatchEvent(new Event('mayhem:mobile-clearance'));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const resize = new ResizeObserver(schedule);
    resize.observe(header);
    if (group) resize.observe(group);
    if (vehicle) resize.observe(vehicle);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    mobile.addEventListener('change', schedule);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
